import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';
import '../../shared/css/modal.css';

import axios from 'axios';
import { headadmin as v_headadmin, basic, Values, SNACKBAR_TIME } from '../../request/values';

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		gridTemplateColumns: '230px 1fr',
	},
	sidebar: {
		display: 'grid',
		gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
		backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
	},
	mainPage: {
		display: 'grid',
		gridTemplateRows: '60px 1fr',
	},
	title: {
		margin: 'auto 0px auto 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WHITE}`,
	},
	logo: {
		display: 'flex',
		alignItems: 'center',
		border: 'solid white',
		cursor: 'pointer',
		borderWidth: '0px 0px 1px 0px',
		'& img': {
			width: 'auto',
			maxHeight: '50%',
			margin: '10px',
		},
		'& #name': {
			display: 'inline-block',
			margin: 'auto 0px auto 0px',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	menu: {
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		'& ul': {
			marginTop: '10px',
			'& li': {
				fontSize: '1rem',
				fontWeight: 'bolder',
				color: `${COLORS.SLATE_GREY}`,
				'& ul': {
					listStyle: 'none',
					paddingLeft: '0px',
					'& li': {
						fontSize: '1rem',
						fontWeight: 'normal',
						margin: '0px',
						cursor: 'pointer',
					},
				},
			},
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '3fr 2fr',
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	form: {
		display: 'flex',
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		margin: 'auto',
		gap: '5%',
		'& input': {
			width: '70%',
			height: '55%',
		},
		'& Button': {
			border: 'solid 1px',
		},
	},
	classList: {
		'& #addMaterial': {
			padding: '5px 25px',
			margin: '1.5vh 0',
			color: `${COLORS.WHITE}`,
			borderRadius: '10px',
			backgroundColor: `${COLORS.WATER_BLUE}`,
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '1fr 7fr 1fr',
		width: '95%',
		height: '60vh',
		margin: '1% auto',
		border: 'solid 2px',
		borderRadius: '10px',
		backgroundColor: `${COLORS.WHITE}`,
	},
	tableTitle: {
		display: 'flex',
		alignItems: 'center',
		padding: '10px 15px',
		border: 'solid lightgray',
		borderWidth: '0 0 2px 0',
	},
	titleName: {
		fontSize: '1rem',
		fontWeight: 'bold',
		color: `${COLORS.SLATE_GREY}`,
	},
	tableInfo: {
		display: 'grid',
		gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 10px',
		'& input': {
			borderColor: 'black',
			borderRadius: '10px',
			maxHeight: '50px',
		},
		'& select': {
			padding: '5px',
			fontFamily: 'Nanumgothic',
			appearance: 'none',
		},
	},
	infoContainer: {
		padding: '5px 30px',
		display: 'grid',
		gridTemplateRows: '30px 1fr',
	},
	buttonContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 15vw 3vw',
	},
	checkInput: {
		borderColor: 'black',
		borderRadius: '10px',
		maxHeight: '50px',
	},
	nonInput: {
		background: 'lightgray',
		color: 'gray',
		borderColor: 'black',
		borderRadius: '10px',
		maxHeight: '50px',
	},
	checkBtn: {
		width: '10vw',
		borderRadius: '10px',
		margin: '0 auto',
		color: `${COLORS.WHITE}`,
		backgroundColor: `${COLORS.PUMPKIN}`,
	},
	nonBtn: {
		width: '10vw',
		borderRadius: '10px',
		margin: '0 auto',
		color: `${COLORS.WHITE}`,
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
}));

const SERVER = basic.server;

export interface propsType {
	searchKeyword: string;
}

const HeadAdminAddMaterial: React.FC<any> = (props) => {
	const classes = useStyles();

	const { member } = props;
	const [materialCode, setMaterialCode] = useState<any | null>();
	const [materialName, setMaterialName] = useState<any | null>();
	const [materialSubName, setMaterialSubName] = useState<any | null>();
	const [materialImage, setMaterialImage] = useState<any | null>();
	const [materialPrice, setMaterialPrice] = useState<any | null>();
	const [auth, setAuth] = useState<boolean>(false);
	const [codevalidate, setflags] = useState<boolean>(true);

	const history = useHistory();

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		if (id == 'materialCode') setMaterialCode(value);
		else if (id == 'materialName') setMaterialName(value);
		else if (id == 'materialSubName') setMaterialSubName(value);
		else if (id == 'materialImage') setMaterialImage(value);
		else if (id == 'materialPrice') setMaterialPrice(value);
	};

	const handleButton = (e: any) => {
		if (auth) {
			enqueueSnackbar(ToastStr.MATERIAL_AUTH_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME });
			setflags(false);
			document.getElementById('materialCode')?.setAttribute('readonly', 'readonly');
		} else {
			// setAnimation(true);
			if (materialCode == null) enqueueSnackbar(ToastStr.MATERIAL_CODE_CHECK_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
			else materialCodeCheck();
		}
	};

	const nothing = () => {};

	const materialCodeCheck = () => {
		setAuth((prevState) => true);
		let url = new URL(SERVER + v_headadmin.headadmin + v_headadmin.auth_material_info);
		let params = { materialCode: materialCode ? materialCode.toString().trim() : '', action: 'join' };
		url.search = new URLSearchParams(params).toString();

		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log(data);
				if (data.code == Values.SUCCESS_CODE) {
					enqueueSnackbar(ToastStr.MATERIAL_CODE_DUPLICATION, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
					setAuth((prevState) => false);
				} else if (data.code == Values.FAIL_CODE) {
					// this is success == dont exist same id
					enqueueSnackbar(ToastStr.MATERIAL_AUTH_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME * 2 });
					setAuth((prevState) => true);
					setflags(false);
					document.getElementById('materialCode')?.setAttribute('readonly', 'readonly');
				}
			});
	};

	const materialAdd = (event: any) => {
		if (!auth) enqueueSnackbar(ToastStr.CHECK_VALIDATE_CODE_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
		else {
			axios({
				method: 'POST',
				data: {
					materialCode: materialCode,
					materialName: materialName,
					materialSubName: materialSubName,
					materialPrice: materialPrice,
					materialImage: materialImage,
					//email: member.id,
					//email: "admin@mittelstand.co.kr",
				},
				withCredentials: true,
				url: SERVER + v_headadmin.headadmin + v_headadmin.material_add,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					console.log(data.code);
					if (data.code == Values.SUCCESS_CODE) {
						enqueueSnackbar(ToastStr.MATERIAL_CREATE_SUCCESS_STR, { variant: 'success', autoHideDuration: SNACKBAR_TIME });
						history.push({
							pathname: '/headadminMateriallist',
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.MATERIAL_CREATE_FAIL_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });
						}
					}
				});
		}
	};

	const moveMaterialList = () => {
		history.push('/headAdminMaterialList');
	};
	const moveProductList = () => {
		history.push('/headAdminLicenseList');
	};
	const moveClassList = () => {
		history.push('/headAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/headAdminClassManage');
	};
	const moveMemberList = () => {
		history.push('/headAdminMemberList');
	};
	const moveAccountManage = () => {
		history.push('/headAdminAccountManage');
	};

	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.sidebar}>
					<div className={classes.logo} onClick={(e) => moveClassList()}>
						<img src="/images/p.webp"></img>
						<Typography id="name">플레이스타트업</Typography>
					</div>
					<div className={classes.userinfo}>
						<Typography id="name">{member.name}님, 환영합니다!</Typography>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								품목 관리
								<ul>
									<li onClick={(e) => moveMaterialList()}>재료 목록</li>
									<li onClick={(e) => moveProductList()}>제품 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								교육 관리
								<ul>
									<li onClick={(e) => moveClassList()}>교육 목록</li>
									<li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								회원 관리
								<ul>
									<li onClick={(e) => moveMemberList()}>회원 목록</li>
									<li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div className={classes.mainPage}>
					<div className={classes.navigator}>
						<div className={classes.title}>재료 추가</div>
						<div className={classes.form}></div>
					</div>
					<div className={classes.classList}>
						<div className={classes.table}>
							<div className={classes.tableTitle}>
								<Typography className={classes.titleName}>재료 정보 입력</Typography>
							</div>
							<div className={classes.tableInfo}>
								<div className={classes.infoContainer}>
									<Typography>재료 코드</Typography>
									<div id="codeContainer">
										<input type="text" id="materialCode" className={codevalidate ? classes.checkInput : classes.nonInput} onChange={valueChangeHandler}></input>
										<Button id="codeValidate" className={codevalidate ? classes.checkBtn : classes.nonBtn} onClick={codevalidate ? handleButton : nothing}>
											<Typography>코드 중복 체크</Typography>
										</Button>
									</div>
								</div>
								<div className={classes.infoContainer}>
									<Typography>재료명</Typography>
									<input type="text" id="materialName" onChange={valueChangeHandler}></input>
								</div>
								<div className={classes.infoContainer}>
									<Typography>상세 재료 명</Typography>
									<input type="text" id="materialDetail" onChange={valueChangeHandler}></input>
								</div>
								<div className={classes.infoContainer}>
									<Typography>가격</Typography>
									<input type="text" id="materialPrice" onChange={valueChangeHandler}></input>
								</div>
								<div className={classes.infoContainer}>
									<Typography>사진</Typography>
									<input type="text" id="materialImage"></input>
								</div>
							</div>
							<div className={classes.buttonContainer}>
								<div></div>
								<Button id="addMaterial" onClick={materialAdd}>
									<Typography>재료 추가하기</Typography>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeadAdminAddMaterial;
